import type { FC } from 'react';
import { Add } from '@mui/icons-material';
import { Accounts } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { LinkButton } from 'components/common';
import { Guard, usePermissionGuard } from 'features/login';

const AccountsPage: FC = () => {
  const { accessToViewFacebookadaccount } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewFacebookadaccount} fallback>
      <CabinetTitlePage
        title={'Accounts'}
        endAdornment={
          <LinkButton
            to={'/cabinet/facebook/accounts/add'}
            title={'Add account'}
            disabled={!accessToViewFacebookadaccount}
            startIcon={<Add />}
          />
        }
      />
      <Accounts />
    </Guard>
  );
};

export default AccountsPage;
